/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  let refreshing = false;
  if (navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      
      console.warn("Auto-reload prevented on controllerchange.");
      /*
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('u', Date.now().toString());
        window.location.replace(url.toString());
      } catch (e) {
        window.location.reload();
      }
      */
    });
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('App is being served from cache by a service worker.')
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New service worker found, installing...')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      // Dispatch an event so the app can show a toast/prompt
      window.dispatchEvent(new CustomEvent('sw-updated', { detail: registration }))
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}

